// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tv-2";
export var container = "_tv-4";
export var dismissButton = "_tv-3";
export var hasPaddingBottom = "_tv-6";
export var last = "_tv-e";
export var scrollbarThumb = "_tv-c";
export var scrollbarTrack = "_tv-b";
export var selected = "_tv-9";
export var spin = "_tv-1";
export var spinning = "_tv-0";
export var suggestionItem = "_tv-d";
export var suggestionsPanel = "_tv-5";
export var tonePill = "_tv-8";
export var tonesContainer = "_tv-7";
export var unselected = "_tv-a";